import yup from "../../../../../validation/yup";
import {MIN_NAME_LENGTH} from "../../../../../validation/lengthConstants";
import {
    generateMinInvalidMessage,
    generateRequiredMessage
} from "../../../../../validation/user";

export const initialValues = {
    title: "",
    unit: ""
};

export const validationSchema = yup.object().shape({
    label: yup
        .string()
        .min(MIN_NAME_LENGTH, generateMinInvalidMessage("Title", MIN_NAME_LENGTH))
        .trim()
        .required(generateRequiredMessage("Title")),
    unit: yup
        .string()
        .min(MIN_NAME_LENGTH, generateMinInvalidMessage("Unit", MIN_NAME_LENGTH))
        .trim()
        .required(generateRequiredMessage("Unit")),
    icon: yup.mixed().required(),
    placeholderIcon: yup.mixed().required(),
})